module.exports = __webpack_public_path__ + "img/unicom-logo.4e12445e.png";